import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { ProductLabel } from "@/components/Product/Layout/ProductLabel/productLabel.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const ProductLabelContainer = () => {
    const { t } = useGranite();

    const { discountPercentage } = useECommerceProduct();

    return (
        <ProductLabel
            text={t("promotionLabel.promo")}
            secondary={`${discountPercentage}%`}
        />
    );
};

export { ProductLabelContainer };
